<template>
  <div>
    <Splash />
    <Sidebar />

    <div style="position: absolute; right: 28vw; width: 51vw; height: auto; top:5.5vw" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="height: auto; margin: 0.5vw;">

        <!-- عنوان -->
        <div class="d-flex justify-content-between mb-3">
          <h2 style="font-size: 1vw !important; width: 14vw;">تدوین برنامه ارتقای بهره وری</h2>
          <button @click="$router.go(-2)" style="width: 5vw; margin-top: 0.5vw;"
                          class="btn btn-primary btn-back">
                    برگشت
                  </button>
        </div>

        <!-- جدول شاخص‌ها -->
        <table class="table table-bordered text-center align-middle mb-4">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>خدمت/زیرخدمت</th>
              <th>شاخص پیامد بهره وری</th>
              <th style="width: 10vw;">عملیات</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(service, sIndex) in services" :key="service.id">
              <template v-for="(indicator, iIndex) in indicators.filter(ind => ind.serviceId === service.id)" :key="indicator.id">
                <tr>
                  <td v-if="iIndex === 0" :rowspan="indicators.filter(ind => ind.serviceId === service.id).length">
                    {{ sIndex + 1 }}
                  </td>
                  <td v-if="iIndex === 0" :rowspan="indicators.filter(ind => ind.serviceId === service.id).length">
                    {{ service.title }}
                  </td>
                  <td v-if="activeIndicator != indicator">{{ indicator.title }}</td>
                  <td v-if="activeIndicator != indicator">
                    <button class="btn btn-sm btn-primary" style="font-size: 0.9vw !important; background: #3742fa; color: #ffffff; border: none;"
                            @click="toggleIndicatorForm(indicator)">
                      تکمیل/بروزرسانی
                    </button>
                  </td>
                </tr>

                <!-- فرم شاخص -->
                <tr v-if="activeIndicator === indicator">
                  <td colspan="4">
                    <div class="card p-3 border border-success" style="background: #ede8e8; border-radius: 0.2vw;">
                      <div style="display: flex; justify-content: space-between;">
                        <p style="text-align: end; margin: 0; cursor: pointer;display: inline-block;" @click="toggleIndicatorForm(indicator)">❌</p>
                      <p style="text-align: end; margin: 0; cursor: pointer;display: inline-block;" @click="submitIndicator(indicator)">💾</p>
                      </div>

                      <h5>{{ indicator.title }}</h5>

                      <!-- وضع موجود -->
                      <div class="mb-3 d-flex align-items-center">
                        <label class="ml-3 mb-0" style="margin-left: 0.3vw;
    margin-top: -0.2vw;">وضع موجود</label>
                        <input type="number" class="form-control w-25" v-model="indicator.currentStatus" />
                      </div>

                      <!-- وضع مطلوب -->
                      <p style="background: #3742f9; padding: 0.5vw; color: white; font-size: 0.9vw; text-align: center; margin-bottom: -0.1vw; border: solid 1px #6d9bb2;">
                        وضع مطلوب
                      </p>
                      <table class="table table-bordered text-center mb-3">
                        <thead>
                          <tr>
                            <th>سال</th>
                            <th>سالانه</th>
                            <th>۶ماهه اول</th>
                            <th>۶ماهه دوم</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="year in years" :key="year">
                            <td>{{ year }}</td>
                            <td><input v-model="indicator.desired[year].year" class="form-control"/></td>
                            <td><input v-model="indicator.desired[year].h1" class="form-control"/></td>
                            <td><input v-model="indicator.desired[year].h2" class="form-control"/></td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- رویکردها -->
                      <button class="btn btn-sm btn-primary mb-3 d-flex align-items-center justify-content-start"
                              style="background: rgb(55, 66, 250);
    color: rgb(255, 255, 255);
    border: none;
    font-size: 0.9vw !important;
    display: flex !important;
    justify-content: space-between !important;border-radius: unset;"
                              @click="indicator.showApproachModal = !indicator.showApproachModal">
                        رویکردهای ارتقای بهره وری
                        <span v-if="indicator.showApproachModal">❌</span>
                        <span  style="margin-top: 0.2vw;" v-else>+</span>
                      </button>

                      <div v-if="indicator.showApproachModal" class="card p-3 mb-3 border border-primary" style="background: #ffffff;
    border-radius: 0;
    border-color: #6d9bb2 !important;
    margin-top: -1vw;">
     <p style="text-align: end; margin: 0; cursor: pointer;display: inline-block;" @click="submitApproaches(indicator)">💾</p>
                        <h6 style="font-size: 1vw !important;">انتخاب رویکرد های مربوطه</h6>
                        <div v-for="approach in indicator.approaches" :key="approach.id" class="mb-2 text-right">
                          <label>
                            <input type="checkbox" v-model="approach.selected" /> {{ approach.title }}
                          </label>

                          <input v-if="approach.isOther && approach.selected" v-model="approach.customTitle" placeholder="عنوان خودتان را وارد کنید" class="form-control w-50 mt-1"/>

                          <div v-if="approach.selected && (!approach.isOther || approach.customTitle)" class="mt-1 p-2" style="background: #fffcfc; border-radius: 0.5vw;">
                            <div class="mb-2 d-flex align-items-center gap-3">
                              <div class="d-flex flex-column">
                                <label>اولویت</label>
                                <input type="number" v-model.number="approach.priority" class="form-control w-100" />
                              </div>
                              <div v-for="(label, index) in dimensionLabels" :key="index" class="d-flex flex-column">
                                <label>امتیاز {{ label.name }}</label>
                                <input type="number" v-model.number="approach.scores['d'+(index+1)]" class="form-control w-100"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- اقدامات -->
                      <button class="btn btn-sm btn-primary mb-3 d-flex align-items-center justify-content-start"
                              style="background: rgb(55, 66, 250);
    color: rgb(255, 255, 255);
    border: none;
    font-size: 0.9vw !important;
    display: flex !important;
    justify-content: space-between !important;border-radius: unset;"
                              @click="indicator.showActionsModal = !indicator.showActionsModal">
                        اقدامات
                        <span v-if="indicator.showActionsModal">❌</span>
                        <span style="margin-top: 0.2vw;" v-else>+</span>
                      </button>
<div v-if="indicator.showActionsModal" class="card p-3 mb-3 border border-secondary" style="background: #ffffff;
    border-radius: 0;
    border-color: #6d9bb2 !important;
    margin-top: -1vw;">

  <div class="five-col-grid">

    <!-- عنوان اقدام -->
    <div class="form-item">
      <label>عنوان اقدام</label>
      <textarea v-model="indicator.newAction.title"
          class="form-control"
          style="
            height: 2vw;
            font-size: 0.8vw;
            line-height: 0.7vw;
            resize: both;
          ">
</textarea>
    </div>

    <div class="form-item">
      <label>وزن اقدام</label>
      <input v-model="indicator.newAction.weight" type="number"
             class="form-control"
             style="height: 2vw;
    font-size: 0.8vw;
    line-height: 0.7vw;"/>
    </div>

    <!-- وضعیت -->
    <div class="form-item">
      <label>وضعیت اقدام</label>
      <select v-model="indicator.newAction.status"
              class="form-control"
              style="height: 2vw;
    font-size: 0.8vw;
    line-height: 0.7vw;">
        <option v-for="status in actionStatuses" :key="status">{{ status }}</option>
      </select>
    </div>

    <!-- چرخه -->
    <div class="form-item">
      <label>دوره چرخه</label>
      <select v-model="indicator.newAction.cycle"
              class="form-control"
             style="height: 2vw;
    font-size: 0.8vw;
    line-height: 0.7vw;">
        <option v-for="year in cycleYears" :key="year">{{ year }}</option>
      </select>
    </div>

    <!-- تاریخ شروع -->
    <div class="form-item">
      <label>تاریخ شروع</label>
      <vue3-persian-datetime-picker
        v-model="indicator.newAction.startDate"
       format="YYYY/MM/DD"
  display-format="jYYYY/jMM/jDD"
  type="date"
  calendar="persian"
  locale="fa"
  output-format="jYYYY/jMM/jDD"
        class="w-100"/>
    </div>

    <!-- تاریخ پایان -->
    <div class="form-item">
      <label>تاریخ پایان</label>
      <vue3-persian-datetime-picker
        v-model="indicator.newAction.endDate"
        format="YYYY/MM/DD"
  display-format="jYYYY/jMM/jDD"
  type="date"
  calendar="persian"
  locale="fa"
  output-format="jYYYY/jMM/jDD"
        class="w-100"/>
    </div>

    <!-- بهار -->
    <div class="form-item">
      <label>پیشرفت بهار 1404</label>
      <input v-model="indicator.newAction.expectedProgress.spring" type="number"
             class="form-control"
             style="height: 2vw;
    font-size: 0.8vw;
    line-height: 0.7vw;"/>
    </div>

    <!-- تابستان -->
    <div class="form-item">
      <label>پیشرفت تابستان 1404</label>
      <input v-model="indicator.newAction.expectedProgress.summer" type="number"
             class="form-control"
             style="height: 2vw;
    font-size: 0.8vw;
    line-height: 0.7vw;"/>
    </div>

    <!-- پاییز -->
    <div class="form-item">
      <label>پیشرفت پاییز 1404</label>
      <input v-model="indicator.newAction.expectedProgress.fall" type="number"
             class="form-control"
             style="height: 2vw;
    font-size: 0.8vw;
    line-height: 0.7vw;"/>
    </div>

    <!-- زمستان -->
    <div class="form-item">
      <label>پیشرفت زمستان 1404</label>
      <input v-model="indicator.newAction.expectedProgress.winter" type="number"
             class="form-control"
             style="height: 2vw;
    font-size: 0.8vw;
    line-height: 0.7vw;"/>
    </div>

    

  </div>
<div >
      <button class="btn btn-sm"
            style="background: rgb(55, 66, 250);
    color: rgb(255, 255, 255);
    border: none;
    font-size: 0.9vw !important;
    margin-top: 1.2vw;
    height: 2vw;
    line-height: 0.7vw;width: 5vw;"
            @click="addAction(indicator)">
      افزودن 
    </button>
    </div>
  

  <!-- لیست اقدامات ثبت‌شده -->
<div v-if="indicator.actions.length" class="mt-4">
  <h6 style="font-size:0.9vw !important">لیست اقدامات</h6>

  <table class="table table-bordered text-center">
  <thead>
    <tr>
      <th>ردیف</th>
      <th>عنوان</th>
      <th>وزن</th>
      <th>وضعیت</th>
      <th>چرخه</th>
      <th>شروع</th>
      <th>پایان</th>
      <th>نماگر</th> <!-- این ستون جدید -->
      <th>عملیات</th>
    </tr>
  </thead>
  <tbody>
    <template v-for="(action, aIndex) in indicator.actions" :key="aIndex">
      <!-- ردیف اصلی اقدام -->
      <tr>
        <td>{{ aIndex+1 }}</td>
        <td>{{ action.title ?? '-' }}</td>
     <td>{{ action.weight ? action.weight : '-' }}</td>

<td>{{ action.status ?? '-' }}</td>
<td>{{ action.cycle ?? '-' }}</td>
<td>{{ action.startDate ?? '-' }}</td>
<td>{{ action.endDate ?? '-' }}</td>

        <td>
          <button class="btn btn-sm btn-primary" style="font-size: 0.8vw !important; background: #3742fa; color: #ffffff; border: none;"
                  @click="toggleKpiForm(action)">
           {{ activeAction === action ? '❌' : 'تکمیل/بروزرسانی' }}
          </button>
        </td>
        <td>
          <button class="btn btn-sm btn-danger" style="font-size: 0.8vw !important; background: red; color: #ffffff; border: none;"
                  @click="removeAction(indicator, aIndex)">
            حذف
          </button>
        </td>
      </tr>

      <!-- فرم نماگر -->
      <tr v-if="activeAction === action">
        <td colspan="9">
          <div class="card p-3" style="background: rgb(237 227 227);
    border-radius: unset;
    border: none;">
            

            <!-- لیست نماگرها -->
            <!-- فرم افزودن نماگر -->
<div class="five-col-grid">

  <div class="form-item">
    <label>عنوان نماگر</label>
  
           
           <textarea v-model="action.newKpi.title"
          class="form-control"
          style="
            height: 2vw;
            font-size: 0.8vw;
            line-height: 0.7vw;
            resize: both;
          ">
</textarea>
  </div>

  <div class="form-item">
    <label>ماهیت پیشرفتی؟</label>
    <select
  v-model="action.newKpi.isProgressBased"
  class="form-control small-input"
>
  <option :value="true">بله</option>
  <option :value="false">خیر</option>
</select>



  </div>

  <div class="form-item">
    <label>هدف کمی و کیفی</label>
    <input v-model="action.newKpi.quantitativeGoal"
           class="form-control small-input"/>
  </div>


  <div class="form-item">
    <label>مسئول</label>
    <input v-model="action.newKpi.responsible"
           class="form-control small-input"/>
  </div>

  <div class="form-item">
  <label>پیشرفت بهار</label>
  <input v-model="action.newKpi.expectedProgress.spring"
         class="form-control small-input" type="number"
         :disabled="action.newKpi.isProgressBased === true"/>
</div>

<div class="form-item">
  <label>پیشرفت تابستان</label>
  <input v-model="action.newKpi.expectedProgress.summer"
         class="form-control small-input" type="number"
         :disabled="action.newKpi.isProgressBased === true"/>
</div>

<div class="form-item">
  <label>پیشرفت پاییز</label>
  <input v-model="action.newKpi.expectedProgress.fall"
         class="form-control small-input" type="number"
         :disabled="action.newKpi.isProgressBased === true"/>
</div>

<div class="form-item">
  <label>پیشرفت زمستان</label>
  <input v-model="action.newKpi.expectedProgress.winter"
         class="form-control small-input" type="number"
         :disabled="action.newKpi.isProgressBased === true"/>
</div>

  <div class="form-item">
    <button class="btn btn-sm"
            style="background: rgb(55, 66, 250);
    color: rgb(255, 255, 255);
    border: none;
    font-size: 0.9vw !important;
    margin-top: 0.7vw;
    height: 2vw;
    line-height: 0.7vw;width: 5vw;"
            @click="saveKpi(action)">
     افزودن
    </button>
  </div>

</div>

<h6 v-if="action.kpis.length" style="font-size: 0.9vw !important;
    margin-top: 1.5vw;
    margin-bottom: 0vw;">لیست نماگرها</h6>
<!-- جدول نماگرهای ثبت‌شده -->
<table v-if="action.kpis.length"
       class="table table-bordered text-center mt-3"
       style="font-size:0.85vw">
  <thead>
    <tr>
      <th>ردیف</th>
      <th>عنوان نماگر</th>
      <th>مسئول</th>
      <th>ماهیت پیشرفتی</th>
      <th>هدف کمی و کیفی</th>
      <th>بهار</th>
      <th>تابستان</th>
      <th>پاییز</th>
      <th>زمستان</th>
      <th>عملیات</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(kpi, kIndex) in action.kpis" :key="kIndex">
      <td>{{ kIndex + 1 }}</td>
      <td>{{ kpi.title }}</td>
     <td>{{ kpi.responsible ? kpi.responsible : '-' }}</td>
      <td>{{ kpi.isProgressBased ? 'بله' : 'خیر' }}</td>
      <td>{{ kpi.quantitativeGoal ? kpi.quantitativeGoal : '-' }}</td>

      <td>{{ kpi.expectedProgress.spring ?? '-' }}</td>
      <td>{{ kpi.expectedProgress.summer ?? '-' }}</td>
      <td>{{ kpi.expectedProgress.fall ?? '-' }}</td>
      <td>{{ kpi.expectedProgress.winter ?? '-' }}</td>
      <td>
        <button class="btn btn-sm btn-danger" style="font-size: 0.8vw !important; background: red; color: #ffffff; border: none;"
                @click="removeKpi(action, kIndex)">
          حذف
        </button>
      </td>
    </tr>
  </tbody>
</table>



          </div>
        </td>
      </tr>
    </template>
  </tbody>
</table>

</div>


</div>




                     
                    </div>
                  </td>
                </tr>

              </template>
            </template>
          </tbody>
        </table>

        <div> 
          <a style="background: #0008ff;
    color: white;
    padding: 0.4vw
6.83px
;
    border-radius: 0.5vw;
    font-size: 0.9vw;
    width: 11vw !important;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    border: none;">خروجی word</a>

    <a style="background: rgb(16 124 19);
    color: white;
    padding: 0.4vw
6.83px
;
    border-radius: 0.5vw;
    font-size: 0.9vw;
    width: 11vw !important;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    margin-right: 1vw;
    border: none;"> ارائه جهت تایید مدیرعامل</a>


        </div>



      </div>
    </div>
  </div>
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  name:"ProductivityTableWithApproachAndActions",
  components:{Splash, Sidebar , Vue3PersianDatetimePicker},
  data(){
    return {
        activeAction: null,
      services:[{id:1,title:"ارائه جزئیات محاسبه صورتحساب"},{id:2,title:"جابجایی علمک"},{id:3,title:"تفکیک کنتور گاز"},{id:4,title:"تغییر نوع مصرف مشترکین"}],
      years:[1405,1406,1407],
      cycleYears: [1400,1401,1402,1403,1404,1405],
      defaultCycle: 1404,
      actionStatuses: ['مصوب','درحال تصویب'],
      dimensionLabels:[
        { name: "توانایی", desc: "(در اختیار داشتن دانش فنی و زیرساخت فناوری، امکان تامین منابع مالی و انسانی، اختیار قانونی)" },
        { name: "جذابیت", desc: "(ارزش افزوده ایجاد شده برای شهروندان، میزان صرفه‌جویی حاصله و …)" },
        { name: "پذیرش", desc: "(میزان پذیرش و همراهی ذینفعان)" },
        { name: "مقیاس‌پذیری", desc: "(در سطح دولت)" },
      ],
      indicators:[
        {id:1,serviceId:1,title:"مساحت ساختمانها و فضاهای اداری",currentStatus:null,desired:{},approaches:[],actions:[],
          newAction: {
            title:'', weight:'', status:'مصوب', startDate:null, endDate:null, cycle:1404, expectedProgress:{spring:null,summer:null,fall:null,winter:null}
          }},
        {id:2,serviceId:1,title:"میزان تحقق اهداف",currentStatus:null,desired:{},approaches:[],actions:[],
          newAction: {
            title:'', weight:'', status:'مصوب', startDate:null, endDate:null, cycle:1404, expectedProgress:{spring:null,summer:null,fall:null,winter:null}
          }},
        {id:3,serviceId:1,title:"شاخص رضایت اربابرجوع",currentStatus:null,desired:{},approaches:[],actions:[],
          newAction: {
            title:'', weight:'', status:'مصوب', startDate:null, endDate:null, cycle:1404, expectedProgress:{spring:null,summer:null,fall:null,winter:null}
          }},
        {id:4,serviceId:2,title:"نرخ دسترسپذیری",currentStatus:null,desired:{},approaches:[],actions:[],
          newAction: {
            title:'', weight:'', status:'مصوب', startDate:null, endDate:null, cycle:1404, expectedProgress:{spring:null,summer:null,fall:null,winter:null}
          }},
        {id:5,serviceId:2,title:"نرخ خطا",currentStatus:null,desired:{},approaches:[],actions:[],
          newAction: {
            title:'', weight:'', status:'مصوب', startDate:null, endDate:null, cycle:1404, expectedProgress:{spring:null,summer:null,fall:null,winter:null}
          }},
        {id:6,serviceId:3,title:"زمان ارائه خدمات",currentStatus:null,desired:{},approaches:[],actions:[],
          newAction: {
            title:'', weight:'', status:'مصوب', startDate:null, endDate:null, cycle:1404, expectedProgress:{spring:null,summer:null,fall:null,winter:null}
          }},
        {id:7,serviceId:3,title:"مساحت ساختمانها و فضاهای اداری",currentStatus:null,desired:{},approaches:[],actions:[],
          newAction: {
            title:'', weight:'', status:'مصوب', startDate:null, endDate:null, cycle:1404, expectedProgress:{spring:null,summer:null,fall:null,winter:null}
          }},
        {id:8,serviceId:4,title:"میزان مصرف انرژی )آب/ برق/ گاز",currentStatus:null,desired:{},approaches:[],actions:[],
          newAction: {
            title:'', weight:'', status:'مصوب', startDate:null, endDate:null, cycle:1404, expectedProgress:{spring:null,summer:null,fall:null,winter:null}
          }},
      ],
      activeIndicator:null,
      
    }
  },
  methods:{

     toggleKpiForm(action) {
    if (this.activeAction === action) {
      this.activeAction = null
    } else {
      this.activeAction = action
    }
  },
  addKpi(action) {
    action.kpis.push({
      title: '',
      isProgressBased: true,
      quantitativeGoal: '',
      qualitativeGoal: '',
      responsible: '',
      expectedProgress: { spring:null, summer:null, fall:null, winter:null }
    })
  },
    toggleIndicatorForm(indicator){
      if(this.activeIndicator === indicator) this.activeIndicator = null
      else {
        this.activeIndicator = indicator
        if(Object.keys(indicator.desired).length===0) this.initDesired(indicator)
        if(!indicator.approaches.length) this.initApproaches(indicator)
        indicator.showApproachModal = false
        indicator.showActionsModal = false
      }
    },
    initDesired(indicator){
      this.years.forEach(y=>indicator.desired[y]={year:null,h1:null,h2:null})
    },
    initApproaches(indicator){
      const fixed=[
        "اصلاح ساختار و معماری کلان دولت",
        "مدیریت سرمایه انسانی",
        "توسعه دولت هوشمند",
        "ارتقاء سلامت اداری و رفع زمینه‌های فساد",
        "ارتقاء نظام مدیریت عملکرد و بهبود کیفیت خدمات",
        "بهره‌وری انرژی",
        "مولدسازی دارایی‌های دولت"
      ]
      indicator.approaches=fixed.map((t,i)=>({
        id:i+1,title:t,selected:false,priority:null,scores:{d1:null,d2:null,d3:null,d4:null},isOther:false,customTitle:null,actions:[]
      }))
      indicator.approaches.push({
        id:999,title:"سایر",selected:false,priority:null,scores:{d1:null,d2:null,d3:null,d4:null},isOther:true,customTitle:null,actions:[]
      })
    },
    submitIndicator(indicator){
    
      toast.success('اطلاعات با موفقیت ثبت گردید')
      this.activeIndicator = null
      this.activeAction=null
    },


    submitApproaches(indicator){
       const hasSelectedApproach = indicator.approaches.some(
    approach => approach.selected && !approach.isOther
  );

  if (!hasSelectedApproach) {
     toast.error('حداقل یک رویکرد باید انتخاب گردد')
    return;
  }
      toast.success('اطلاعات با موفقیت ثبت گردید')
      
    },

    // اقدامات
addAction(indicator){
  const action = {
    ...indicator.newAction,
    kpis: [],
    newKpi: {
      title: '',
      isProgressBased: true,
      quantitativeGoal: '',
      qualitativeGoal: '',
      responsible: '',
      expectedProgress: {
        spring: null,
        summer: null,
        fall: null,
        winter: null
      }
    }
  }

  if(!action.title){
    
     toast.error('عنوان اقدام الزامی است')
    return
  }

  indicator.actions.push(action)

  indicator.newAction = { 
    title:'', status:'مصوب',
    startDate:null, endDate:null,
    cycle:1404,
    expectedProgress:{spring:null,summer:null,fall:null,winter:null}
  }
}

,
    removeAction(indicator, index){
      indicator.actions.splice(index,1)
    },
    editAction(indicator, index){
      const action = indicator.actions[index]
      indicator.newAction = {title: action.title, weight: action.weight}
      indicator.actions.splice(index,1)
    },
   addKpi(action) {
  action.kpis.push({
    title: '',
    isProgressBased: true,
    quantitativeGoal: '',
    qualitativeGoal: '',
    responsible: '',
    expectedProgress: {
      spring: null,
      summer: null,
      fall: null,
      winter: null
    }
  })
}
,
saveKpi(action){
  if(!action.newKpi.title){
    toast.error('عنوان نماگر الزامی است')
    return
  }

  action.kpis.push({ ...action.newKpi })

  // ریست فرم
  action.newKpi = {
    title: '',
    isProgressBased: true,
    quantitativeGoal: '',
    qualitativeGoal: '',
    responsible: '',
    expectedProgress: {
      spring: null,
      summer: null,
      fall: null,
      winter: null
    }
  }
}
,
    removeKpi(action,kIndex){
      action.kpis.splice(kIndex,1)
    }
  },
  watch: {
  'action.newKpi.isProgressBased'(val) {
    if (val) {
      this.action.newKpi.expectedProgress = {
        spring: null,
        summer: null,
        fall: null,
        winter: null
      }
    }
  }
}

}
</script>

<style>
input{margin-bottom:.25rem;}
.five-col-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* پنج ستون مساوی */
  gap: 1vw; /* فاصله بین ستون‌ها */
  align-items: center;
}

.form-item {
  display: flex;
  flex-direction: column;
}

label
{
    font-size: 0.8vw !important;
}

.small-input {
  height: 2vw;
  font-size: 0.8vw;
  line-height: 0.7vw;
}

</style>
